import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const storage = {
    fetch() {
        const arr = [];
        if (localStorage.length > 0) {
            for (let i = 0; i < localStorage.length; i++){
                if (localStorage.key(i) !== 'loglevel:webpack-dev-server'){
                    arr.push(JSON.parse(localStorage.getItem(localStorage.key(i))));
                }
            }
        }
        return arr;
    },
};


export const store = new Vuex.Store({
    state: {
        todoItems : storage.fetch(),
    },
    getters: {
        storedTodoItems(state) {
            return state.todoItems;
        }
    },
    mutations:{
        addTodo(state, newTodoItem) {
            if(localStorage.getItem(newTodoItem) == null) {
                const obj = {completed: false, highlight: false, item: newTodoItem};
                localStorage.setItem(newTodoItem, JSON.stringify(obj));
                state.todoItems.push(obj);
            }
            else
                alert("중복된 TODO");
        },
        clearAll(state) {
            localStorage.clear();
            state.todoItems = [];
        },
        removeTodo(state, payload) {
            localStorage.removeItem(payload.todoItem.item);
            state.todoItems.splice(payload.index, 1);
        },
        editTodo(state, payload) {
            // {todoItem, index, editItem}                     // {itemToChange, indexToChange, editItem}
            
            // localStorage.removeItem(payload.todoItem.item);
            // state.todoItems[payload.index].item = payload.editItem;
            // localStorage.setItem(payload.todoItem.item, JSON.stringify(payload.todoItem));

            localStorage.removeItem(payload.oldItem.item);              // key 가지고 지우고
            state.todoItems[payload.oldIndex].item = payload.editItem;  // todoItems에서 객체의 item속성만 변경
            localStorage.setItem(payload.oldItem.item, JSON.stringify(payload.oldItem));
            
        },
        clearDone(state) {
            for (let i = 0; i < localStorage.length; i++){
                if(localStorage.key(i) !== 'loglevel:webpack-dev-server'){
                    var doneItem = JSON.parse(localStorage.getItem(localStorage.key(i)));
          
                    if(doneItem.completed == true){
                        for(let j = 0; j < state.todoItems.length; j++){
                           if(state.todoItems[j].item == doneItem.item){
                                state.todoItems.splice(j, 1);
                                localStorage.removeItem(doneItem.item);
                                i--;
                           }
                        }
                    }
                }
            }
        },
        toggleComplete(state, payload) {
            state.todoItems[payload.index].completed = !state.todoItems[payload.index].completed;
            localStorage.removeItem(payload.todoItem.item);
            localStorage.setItem(payload.todoItem.item, JSON.stringify(payload.todoItem));
        },
        highlight(state, payload) {
            state.todoItems[payload.index].highlight = !state.todoItems[payload.index].highlight;
            localStorage.removeItem(payload.todoItem.item);
            localStorage.setItem(payload.todoItem.item, JSON.stringify(payload.todoItem));
        },
        sort(state){
            // console.log(this.$store.state.todoItems);
            var temp = [];
            for(let i = 0; i < state.todoItems.length; i++) {
              if (state.todoItems[i].highlight == true && state.todoItems[i].completed == false) {
                temp.push(state.todoItems[i]);
                state.todoItems.splice(i, 1);
                i--;
              }
            }
            for(let i = 0; i < state.todoItems.length; i++) {
              if (state.todoItems[i].completed == false) {
                temp.push(state.todoItems[i]);
                state.todoItems.splice(i, 1);
                i--;
              }
            }
            for(let i = 0; i < state.todoItems.length; i++) {
                temp.push(state.todoItems[i]);
                state.todoItems.splice(i, 1);
                i--;
            }
          
            console.log(temp);
            state.todoItems = temp;
          }
    },
});


// WEBPACK FOOTER //
// ./src/store/store.js